import { Meta } from '../../Meta';
import React from 'react';
import { MarketingPage } from '../../marketing/MarketingPage';
import { CaseStudyPostsSection } from './CaseStudyPostsSection';
import { CaseStudyHeroSection } from './CaseStudyHeroSection';
import { CaseStudySummary } from '../utils';

interface Props {
  caseStudies: CaseStudySummary[];
}

export const CaseStudyHome = ({ caseStudies}: Props) => (
  <MarketingPage>
    <Meta title="Case Study">
      <meta property="og:title" content="Wolfia - Case Studies" />
      <meta property="og:image" content="/images/meta/og-image.jpg" />
      <meta
        property="og:description"
        content="10x Faster Security Reviews for Modern companies"
      />
    </Meta>
    <CaseStudyHeroSection />
    <CaseStudyPostsSection caseStudies={caseStudies} />
  </MarketingPage>
);